import { ConsentService } from '../services/consentService';
import { ConsentState } from '../services/consentState';
import { ConsentReceiver } from './consentReceiver';

export class GoogleAnalyticsComponent extends ConsentReceiver {
  private static googleAnalyticsComponentInstance: GoogleAnalyticsComponent;
  private isInitialized: boolean;
  private readonly consentService: ConsentService;
  private readonly trackingId: string;

  public static get instance(): GoogleAnalyticsComponent {
    if (!GoogleAnalyticsComponent.googleAnalyticsComponentInstance) {
      if (!Object.prototype.hasOwnProperty.call(window, 'trackingId')) {
        window.trackingId = null;
      }

      if (!Object.prototype.hasOwnProperty.call(window, 'dataLayer')) {
        window.dataLayer = [];
      }

      GoogleAnalyticsComponent.googleAnalyticsComponentInstance = new GoogleAnalyticsComponent(window.trackingId);
    }

    return GoogleAnalyticsComponent.googleAnalyticsComponentInstance;
  }

  protected constructor(trackingId: string) {
    super();
    this.trackingId = trackingId;
    this.consentService = ConsentService.instance;
  }

  public init() {
    if (!this.trackingId) {
      return;
    }

    this.consentService.registerReceiver(this);
    this.handleConsentChange();
  }

  public handleConsentChange() {
    if (this.consentService.consentIsSet) {
      const ad_storage = this.consentService.checkConsent(ConsentState.ADVERTISING) ? 'granted' : 'denied';
      const analytics_storage = this.consentService.checkConsent(ConsentState.ANALYTICS) ? 'granted' : 'denied';

      if (!this.isInitialized) {
        this.gtag('consent', 'default', { ad_storage, analytics_storage });
        this.gtag('js', new Date());
        this.gtag('config', this.trackingId, {
          'anonymize_ip': true,
          'cookie_domain': 'none',
          'cookie_expires': 365 * 24 * 60 * 60, // number of days in a year
        });
        this.isInitialized = true;
      } else {
        this.gtag('consent', 'update', { ad_storage, analytics_storage });
      }
    } else {
      this.consentService.removeNonConsentedCookies([ConsentState.ANALYTICS]);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private gtag(...args: unknown[]) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
}
